<template>
  <v-dialog v-model="dialog" :width="dialogWidth">
    <template v-slot:activator="{ on, attrs }">
      <v-card
        class="mx-auto no-shadow theme-card"
        max-width="344"
        v-if="expoData"
        v-bind="attrs"
        v-on="on"
      >
        <v-img :aspect-ratio="16 / 9" :src="expoData.sceneImage.url">
          <!-- <label>{{ expoData.plan }}</label> -->
        </v-img>
        <v-card-title>{{ expoData.name }}</v-card-title>
      </v-card>
    </template>

    <v-card class="preview_container no-shadow">
      <v-row class="ma-0">
        <v-spacer></v-spacer>
        <v-icon @click="closePop">mdi-window-close</v-icon>
      </v-row>
      <v-scale-transition>
        <v-row
          class="flex-nowrap"
          v-if="currentStep == step.SELECTTHEME && this.dialog"
        >
          <v-col cols="8">
            <v-card max-width="660" class="no-shadow">
              <div
                class="preview"
                v-if="
                  expoData.previewJson !== null &&
                  expoData.previewJson[selectItem]?.type
                "
              >
                <iframe
                  v-if="expoData.previewJson[selectItem]?.type === 'iframe'"
                  :src="expoData.previewJson[selectItem].value"
                  frameborder="0"
                ></iframe>
                <img
                  v-if="expoData.previewJson[selectItem]?.type === 'image'"
                  :src="expoData.previewJson[selectItem].value"
                  alt=""
                />
                <div
                  class="embed-container"
                  v-if="expoData.previewJson[selectItem]?.type === 'youtube'"
                >
                  <iframe
                    width="560"
                    height="315"
                    :src="getYtID()"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    v-if="expoData.previewJson[selectItem]?.type === 'youtube'"
                  ></iframe>
                </div>
              </div>
              <div class="preview" v-if="expoData.previewJson === null">
                <img
                  v-if="expoData.previewJson === null"
                  :src="
                    require(`@/assets/images/exhibition/create_theme/noPreview_${lang}.png`)
                  "
                  alt=""
                />
                <SizeBox height="20" />
              </div>
              <v-sheet class="mx-auto" v-if="expoData.previewJson !== null">
                <v-slide-group
                  v-model="selectItem"
                  :show-arrows="false"
                  center-active
                >
                  <v-slide-item
                    v-for="preview in expoData.previewJson"
                    :key="preview.value"
                    v-slot="{ active, toggle }"
                  >
                    <v-card
                      class="ma-2 d-flex align-center justify-center slide-card"
                      height="96"
                      width="156"
                      @click="!active && toggle()"
                      style="overflow: hidden"
                    >
                      <div
                        v-if="!active"
                        class="mask"
                        style="
                          position: absolute;
                          top: 0;
                          left: 0;
                          right: 0;
                          bottom: 0;
                          z-index: 9;
                          background-color: #070707;
                          opacity: 0.7;
                        "
                      ></div>
                      <div
                        class="thumbnail fill-height w100p"
                        :style="{
                          backgroundImage: `url(${preview.previewImg})`
                        }"
                        style="background-size: cover"
                      ></div>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                        style="position: absolute; left: 0; right: 0"
                      >
                        <v-scale-transition>
                          <v-icon
                            v-if="preview?.type !== 'image'"
                            color="white"
                            size="48"
                            v-text="
                              preview?.type === 'youtube'
                                ? 'mdi-play-circle-outline'
                                : 'mdi-map-marker-outline'
                            "
                          ></v-icon>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card class="no-shadow detail" color="neutral800">
              <v-card-title class="pt-0">
                <label>{{ $t(expoData.planKey) }}</label>
                {{ expoData.name }}
              </v-card-title>
              <v-card-text>
                <v-chip :ripple="false" color="neutral600">
                  <v-icon left>mdi-upload</v-icon>
                  {{ $t('COMMON.COPYWRITING.NUMBER_OF_ITEMS') }}
                  {{ uploadCount }}
                </v-chip>
              </v-card-text>
              <v-card-text class="pt-0 pb-8">
                {{
                  expoData.description
                    ? expoData.description
                    : $t('SPACE.COPYWRITING.NO_INTRODUCTION')
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn
                  depressed
                  color="#fff"
                  height="46"
                  class="w100p"
                  @click="chooseTheme"
                  style="background-color: #00b6f0; font-size: 16px"
                >
                  <v-icon left dark v-if="isLock">mdi-lock-outline</v-icon>
                  {{
                    isLock
                      ? $t('SPACE.EDIT.COPYWRITING.UPGRADE')
                      : $t('SPACE.EDIT.COPYWRITING.SELECT_THEME')
                  }}
                </v-btn>
              </v-card-actions>
              <p v-if="isLock" class="update_tip">
                {{
                  $t(
                    'SPACE.EDIT.COPYWRITING.THEME_UNAVAILABLE_PLEASE_UPGRADE_TO'
                  )
                }}
                <span>
                  {{ $t(expoData.planKey) }} {{ $t('PLAN.WORD.PLAN') }}
                </span>
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-scale-transition>
      <v-scale-transition>
        <v-row
          v-if="currentStep === step.CREATETHEME"
          class="set_detail"
          style="padding: 0 20px"
        >
          <v-form ref="form" @submit.prevent>
            <h2 style="font-size: 20px" class="pa-4 pb-0 pt-0">
              {{ $t('SPACE.EDIT.COPYWRITING.ENTER_SPACE_URL') }}
            </h2>
            <div class="pa-4 w100p">
              <div class="d-flex align-center">
                <span
                  class="text-16 font-weight-bold neutral100--text"
                  style="line-height: 2"
                >
                  {{ $t('SPACE.EDIT.COPYWRITING.SPACE_NAME') }}
                  <div style="display: inline-block; color: #ff5084">*</div>
                </span>
              </div>

              <div class="w100p text-14px subtitle">
                <div>
                  {{
                    $t('SPACE.EDIT.COPYWRITING.SPACE_NAME_CAN_BE_CHANGED_LATER')
                  }}
                </div>
              </div>

              <SizeBox height="15" />

              <div class="flex-center">
                <div class="w100p">
                  <v-text-field
                    :label="$t('SPACE.EDIT.COPYWRITING.ENTER_SPACE_NAME')"
                    counter="30"
                    :maxlength="30"
                    solo
                    v-model="name"
                    :rules="[
                      (v) => $rules.required(v, '空間名稱不能為空！'),
                      (v) => $rules.maxLength(v, 30)
                    ]"
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div class="pa-4 w100p">
              <div class="d-flex align-center">
                <span
                  class="text-16 font-weight-bold neutral100--text"
                  style="line-height: 2"
                >
                  {{ $t('SPACE.EDIT.WORD.URL') }}
                  <div style="display: inline-block; color: #ff5084">*</div>
                </span>
              </div>

              <div class="w100p text-14px subtitle">
                <div>
                  {{ $t('SPACE.EDIT.COPYWRITING.ENTER_URL_CANNOT_BE_CHANGED') }}
                </div>
              </div>

              <SizeBox height="15" />
              <div class="flex-center">
                <div class="w100p">
                  <v-text-field
                    :label="$t('SPACE.EDIT.WORD.URL')"
                    solo
                    counter="30"
                    :maxlength="30"
                    v-model="alias"
                    :prefix="`${$frontPageURL}/`"
                    :rules="[
                      (v) =>
                        $rules.required(
                          v,
                          $t('SPACE.EDIT.INPUT.ALERT.URL_IS_REQUIRED')
                        ),
                      (v) =>
                        /^[a-zA-Z0-9-_]+$/.test(v) ||
                        $t('SPACE.EDIT.INPUT.ALERT.URL_NOT_CONFORM_RULES'),
                      (v) => $rules.maxLength(v, 30)
                    ]"
                    :error-messages="aliasError"
                    :hint="
                      $t(
                        'SPACE.EDIT.INPUT.REMIND.NAMES_AUTOMATICALLY_LOWERCASE'
                      )
                    "
                  >
                    <template #append v-if="isCheckingAlias">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
            <div class="w100p">
              <SizeBox height="6" />
              <v-divider></v-divider>
              <SizeBox height="12" />
            </div>
            <v-card-actions class="flex-center pa-4 build_btn">
              <v-btn depressed @click="closePop">
                {{ $t('COMMON.WORD.CANCEL') }}
              </v-btn>
              <SizeBox width="24" />
              <v-btn
                color="primary"
                depressed
                @click="submit"
                :loading="isCheckingAlias"
              >
                {{ $t('COMMON.WORD.CREATE') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-row>
      </v-scale-transition>
    </v-card>
  </v-dialog>
</template>
<script>
const STEP = {
  SELECTTHEME: 1,
  CREATETHEME: 2
};
import { mapGetters } from 'vuex';
import { addExhibition, checkExhibitionsAlias } from '@/api/panel/exhibitions';
export default {
  props: {
    expoData: {
      type: Object,
      defaults: {}
    },
    currentTab: {
      type: Number
    }
  },
  data: () => ({
    dialog: false,
    selectItem: 0,
    alias: '',
    aliasError: null,
    isCheckingAlias: false,
    name: '',
    step: STEP,
    currentStep: 1
  }),
  computed: {
    ...mapGetters({
      Team: 'auth/getTeam',
      User: 'auth/getUser'
    }),
    permissionAssets() {
      return this?.Team?.permissionAsset || {};
    },
    lang() {
      return localStorage.getItem('language').toLowerCase();
    },
    teamGroup() {
      return this?.permissionAssets?.teamGroup || {};
    },
    computedRenderInfoCard() {
      if (this.teamGroup.alias) return this.teamGroup.alias;
      else return 'free';
    },
    isLock() {
      if (this.expoData.plan === '進階') {
        if (this.computedRenderInfoCard === 'advanced') return false;
        else {
          if (
            this.computedRenderInfoCard !== 'creator' &&
            this.computedRenderInfoCard !== 'free' &&
            this.expoData.cusHas
          )
            return false;
          else return true;
        }
      } else if (this.expoData.plan === '創作者') {
        if (this.computedRenderInfoCard === 'free') return true;
        else if (
          this.computedRenderInfoCard !== 'creator' &&
          this.computedRenderInfoCard !== 'advanced' &&
          !this.expoData.cusHas
        )
          return true;
        else return false;
      } else {
        return false;
      }
    },
    dialogWidth() {
      return this.currentStep === this.step.CREATETHEME ? '620' : '1116';
    },
    uploadCount() {
      let newArr = [];
      newArr = this.expoData.settingJson.editorAssetProjections.filter(
        (item) => {
          return item?.type !== 'keyVision' && item?.type !== 'keyVision3D';
        }
      );
      return newArr.length;
    }
  },
  methods: {
    getYtID() {
      const urlSplitArr =
        this.expoData.previewJson[this.selectItem].value.split('/');
      return `https://www.youtube-nocookie.com/embed/${
        urlSplitArr[urlSplitArr.length - 1]
      }?rel=0`;
    },
    async submit() {
      let flag = true;
      console.log(!this.$refs.form.validate());
      if (!this.$refs.form.validate()) flag = false;
      if (!(await this.checkAlias())) flag = false;
      // if (!this.$refs.ScenePicker.$validate()) flag = false;
      if (!flag) return;

      const { error } = await addExhibition({
        sceneId: this.expoData.id,
        name: this.name,
        alias: this.alias.toLowerCase()
      });

      if (!error) {
        this.$toast(this.$t('SPACE.EDIT.TOAST.SUCCESS.CREATE_SUCCESFUL'));
        this.$router.replace({ name: 'exhibitions' });
      } else {
        this.$toast.error('創建失敗');
      }
    },
    async checkAlias() {
      this.aliasError = null;
      this.isCheckingAlias = true;

      const { isAllowed } = await checkExhibitionsAlias({
        alias: this.alias
      });
      if (!isAllowed) {
        this.aliasError = this.$t(
          'SPACE.EDIT.INPUT.ALERT.URL_ALREADY_USED_PLEASE_TRY_ANOTHER'
        );
      }
      this.isCheckingAlias = false;

      return isAllowed;
    },
    closePop() {
      this.dialog = false;
      this.currentStep = this.step.SELECTTHEME;
      this.name = '';
      this.alias = '';
    },
    chooseTheme() {
      if (this.isLock) this.$router.push({ name: 'update-account' });
      else this.currentStep = this.step.CREATETHEME;
    }
  }
};
</script>
<style lang="scss" scoped>
.preview_container {
  padding: 2% 2.5%;
  border: 24px;
  background-color: $neutral800;
  .preview {
    padding: 28%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 0.5%;
    iframe,
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    img {
      object-fit: cover;
    }
    .embed-container {
      position: absolute;
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;
      max-width: 100%;
      width: 100%;
      left: 0;
      top: 0;
    }
    .embed-container iframe,
    .embed-container object,
    .embed-container embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .slide-card {
    &:nth-of-type(1) {
      margin-left: 0 !important;
    }
    &:nth-last-child(1) {
      margin-right: 0 !important;
    }
  }
  .detail {
    .v-card__title {
      font-size: 1.25rem;
      width: calc(100% - 37px);
      label {
        font-size: 12px;
        background-color: $primary500;
        border-radius: 4px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        padding: 0 6px;
      }
    }
    .v-chip {
      i {
        font-size: 20px;
      }
    }
    .update_tip {
      text-align: center;
      font-size: 12px;
      color: $neutral300;
      span {
        color: $primary300;
      }
    }
  }
}
.set_detail {
  .subtitle {
    color: $neutral200;
  }
  .build_btn {
    width: 100%;
    margin-bottom: 10px;
    button {
      width: calc(50% - 12px);
      height: 41px;
      &:nth-of-type(1) {
        color: $neutral200;
        background-color: $neutral600;
      }
    }
  }
  ::v-deep {
    .v-input {
      .v-input__control {
        position: relative;
      }
      .v-input__slot {
        background-color: $neutral700;
        .v-label {
          color: $neutral400;
        }
      }
      .v-text-field__details {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        .v-messages {
          display: none;
        }
      }
    }
  }
}
::v-deep {
  .v-dialog {
    overflow: hidden;
    max-width: 1116px;
    &.set_detail {
      max-width: 620px;
    }
  }
  .v-slide-group__prev,
  .v-slide-group__next {
    display: none;
  }
  .v-slide-group__wrapper {
    overflow-x: auto; /* Enables the horizontal scrollbar */
    /* Next lines hides scrollbar in different browsers for styling purposes */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .v-slide-group__wrapper::-webkit-scrollbar {
    display: none; /* Chrome opera and Safary */
    width: 0px;
    background: transparent;
  }
}
.theme-card {
  background-color: transparent;
  cursor: pointer;
  ::v-deep {
    .v-image {
      background-color: #fff;
      border-radius: 6px;
      label {
        position: absolute;
        left: 10px;
        top: 10px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        padding: 2px 6px;
        font-size: 12px;
      }
    }
    .v-card__title {
      justify-content: center;
      font-size: 1rem;
      padding: 5px 16px;
    }
  }
}
</style>